export const dateToCalendarEntry = (rawCurrentDate) => {
  return `${rawCurrentDate.getUTCFullYear()}-${String((rawCurrentDate.getUTCMonth() + 1)).padStart(2, 0)}-${String((rawCurrentDate.getUTCDate())).padStart(2, 0)}`
}

export const trimCalendarDate = (dateString) => {
  // YYYY-mm-dd -> YYYY-mm

  if (dateString instanceof Date) {
    dateString = dateToCalendarEntry(dateString)
  }

  if (dateString.split('-').length === 3) {
    return dateString.slice(0, -3)
  } else {
    return dateString
  }
}

export const isCalendarLabelCorrect = (value) => {
  const dashes = value.split('-').length
  if (value === '') {
    return false
  } else if (dashes === 3) {
    return true
  } else if (dashes === 2) {
    return false
  } else {
    return false
  }
}
